import { render, staticRenderFns } from "./ListAddNew.vue?vue&type=template&id=baf6422c"
import script from "./ListAddNew.vue?vue&type=script&lang=js"
export * from "./ListAddNew.vue?vue&type=script&lang=js"
import style0 from "./ListAddNew.vue?vue&type=style&index=0&id=baf6422c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports